import { useNavigate, useLocation } from "react-router-dom";
import { JobAdmin } from "../../types/jobAdmin";
import { MapPin, Clock } from "lucide-react";
import Button from "../atoms/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useJobPostStore } from "../../store/useJobPostStore";

export default function AdminJobCard({ job }: { job: JobAdmin }) {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  const isOpen = job.status === "open";
  const isClosed = job.status === "closed";

  const draft = job.status === "draft";

  const { deleteJob, fetchAllJobs } = useJobPostStore();

  const handleDelete = async () => {
    const confirmDelete = window.confirm(
      lang === "id"
        ? "Apakah Anda yakin ingin menghapus lowongan ini?"
        : "Are you sure you want to delete this job?"
    );
    if (!confirmDelete) return;

    const result = await deleteJob(job.id);
    if (result.success) {
      toast.success(result.message || (lang === "id" ? "Lowongan berhasil dihapus!" : "Job deleted successfully!"));
      fetchAllJobs(lang); // refresh list
    } else {
      toast.error(result.error?.message || (lang === "id" ? "Gagal menghapus lowongan." : "Failed to delete job."));
    }
  };

  const handleCopyLink = async () => {
    const url = `https://talentlinkindo.com/${lang}/jobs/${job.id}`;

    try {
      await navigator.clipboard.writeText(url);
      toast.success(lang === "id" ? "Link berhasil disalin" : "Link copied successfully");
    } catch (err) {
      toast.error(lang === "id" ? "Gagal menyalin link" : "Failed to copy link");
    }
  };

  if (isOpen) {
    return (
      <div className="border rounded-xl bg-white p-6 mt-4 shadow-sm">
        <div className="flex flex-col md:flex-row justify-between gap-6">
          {/* Left */}
          <div>
            <h2 className="text-xl font-semibold">{job.job_title}</h2>

            <div className="flex gap-2 flex-col text-gray-600 mt-1">
              <span className="flex items-center gap-1">
                <MapPin size={14} /> {job.country}, {job.state}, {job.city}
              </span>

              <span className="flex items-center gap-1">
                IDR {job.min_salary?.toLocaleString()} – IDR {job.max_salary?.toLocaleString()}
              </span>
            </div>

            <p className="flex items-center gap-1 text-red-500 mt-2">
              <Clock size={14} /> {lang === "id" ? "Tutup" : "Closing"} {job.closing ?? "-"}
            </p>

            <div className="flex items-center gap-6 text-primary mt-6">
              <button
                onClick={handleCopyLink}
                className="hover:underline"
              >
                {lang === "id" ? "Bagikan" : "Share"}
              </button>
              <button onClick={() => navigate(`/${lang}/admin/job-post/edit/${job.id}`)}>
                {lang === "id" ? "Edit" : "Edit"}
              </button>
            </div>



          </div>

          {/* Right */}
          <div className="flex flex-col w-full md:w-auto items-center md:items-end justify-center gap-4">
            <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
              <div className="border rounded-xl px-8 py-4 text-center">
                <p className="text-2xl font-bold">{job.applicants ?? 0}</p>
                <p className="text-sm text-gray-600">{lang === "id" ? "Pelamar" : "Applicants"}</p>
              </div>
            </div>

            <Button
              textClass="text-white"
              onClick={() => navigate(`/${lang}/admin/job-post/candidate/${job.id}`)}
              className="w-full md:w-auto"
            >
              {lang === "id" ? "Kelola Kandidat" : "Manage Candidates"}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (draft) {
    return (
      <div className="border rounded-xl bg-white p-6 mt-4 shadow-sm">
        <h2 className="text-xl font-semibold">{job.job_title}</h2>
        <p className="text-gray-600 mt-1">
          <MapPin size={14} className="inline mr-1" /> {job.country}, {job.state}, {job.city}
        </p>
        <p className="mt-1 text-gray-600">
          IDR {job.min_salary?.toLocaleString()} – IDR {job.max_salary?.toLocaleString()}
        </p>
        {/* <p className="text-sm text-gray-500 mt-2">Created on {job.created}</p> */}

        <div className="flex gap-6 mt-4 text-primary">
          <button onClick={() => navigate(`/${lang}/admin/job-post/edit/${job.id}`)}>
            {lang === "id" ? "Edit" : "Edit"}
          </button>
          <button onClick={handleDelete}>
            {lang === "id" ? "Hapus" : "Delete"}
          </button>
        </div>

      </div>
    );
  }

  

  if (isClosed) {
    return (
      <div className="border rounded-xl bg-white p-6 mt-4 shadow-sm">
        <div className="flex flex-col md:flex-row justify-between gap-6">
          {/* Left */}
          <div>
            <h2 className="text-xl font-semibold">{job.job_title}</h2>

            <div className="flex gap-2 flex-col text-gray-600 mt-1">
              <span className="flex items-center gap-1">
                <MapPin size={14} /> {job.country}, {job.state}, {job.city}
              </span>

              <span className="flex items-center gap-1">
                IDR {job.min_salary?.toLocaleString()} – IDR {job.max_salary?.toLocaleString()}
              </span>
            </div>

            <p className="flex items-center gap-1 text-red-500 mt-2">
              <Clock size={14} /> {lang === "id" ? "Tutup" : "Closing"} {job.closing ?? "-"}
            </p>

            {/* <div className="flex items-center gap-6 text-primary mt-6">
              <button
                onClick={handleCopyLink}
                className="hover:underline"
              >
                {lang === "id" ? "Bagikan" : "Share"}
              </button>
              <button onClick={() => navigate(`/${lang}/admin/job-post/edit/${job.id}`)}>
                {lang === "id" ? "Edit" : "Edit"}
              </button>
            </div> */}

            <div className="flex gap-6 mt-4 text-primary">
              {/* <button onClick={() => navigate(`/${lang}/admin/job-post/edit/${job.id}`)}>
                {lang === "id" ? "Edit" : "Edit"}
              </button> */}
              <button onClick={handleDelete}>
                {lang === "id" ? "Hapus" : "Delete"}
              </button>
            </div>
            



          </div>

          {/* Right */}
          <div className="flex flex-col w-full md:w-auto items-center md:items-end justify-center gap-4">
            <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
              <div className="border rounded-xl px-8 py-4 text-center">
                <p className="text-2xl font-bold">{job.applicants ?? 0}</p>
                <p className="text-sm text-gray-600">{lang === "id" ? "Pelamar" : "Applicants"}</p>
              </div>
            </div>

            <Button
              textClass="text-white"
              onClick={() => navigate(`/${lang}/admin/job-post/candidate/${job.id}`)}
              className="w-full md:w-auto"
            >
              {lang === "id" ? "Kelola Kandidat" : "Manage Candidates"}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // OTHER STATUS: draft, in-review, rejected, closed
  return (
    <div className="border rounded-xl bg-white p-6 mt-4 shadow-sm">
      <h2 className="text-xl font-semibold">{job.job_title}</h2>
      <p className="text-gray-600 mt-1">
        <MapPin size={14} className="inline mr-1" /> {job.country}, {job.state}, {job.city}
      </p>
      <p className="mt-1 text-gray-600">
        IDR {job.min_salary?.toLocaleString()} – IDR {job.max_salary?.toLocaleString()}
      </p>
      {/* <p className="text-sm text-gray-500 mt-2">Created on {job.created}</p> */}

      {/* <div className="flex gap-6 mt-4 text-primary">
      <button onClick={() => navigate(`/${lang}/admin/job-post/edit/${job.id}`)}>
        {lang === "id" ? "Edit" : "Edit"}
      </button>
      <button>{lang === "id" ? "Hapus" : "Delete"}</button>
    </div> */}

    </div>
  );
}
